import { render, staticRenderFns } from "./BsRadio.vue?vue&type=template&id=4d68e839&scoped=true&lang=html&"
import script from "./BsRadio.vue?vue&type=script&lang=js&"
export * from "./BsRadio.vue?vue&type=script&lang=js&"
import style0 from "./BsRadio.vue?vue&type=style&index=0&id=4d68e839&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d68e839",
  null
  
)

export default component.exports